import React, { useEffect } from 'react';
import { useState } from "react"
import { useFinanceCheck } from '../../hooks/useFinanceCheck';
import { formatReal } from 'src/utils/format';

const FinanceCheckComponent = ({project_id}) => {


    const {loadGlobal, salesData, financeData, checkSalesNotFoundInSaldo, checkSalesNotPaidInSaldo, checkByOperation} = useFinanceCheck();

const [ready, setReady] = useState(false);
const [step,setStep] = useState('home');

/*questions to mark

Sales not indentified
Finance Report Resume

*/

const load = async () => {

await loadGlobal(project_id);

setReady(true)


}

useEffect(() => {


load()

},[])

if(!ready){

    return <h2 style={{color: '#333', textAlign:'center', width:'100%', marginTop:'50px'}}>Carregando...</h2>

}

return <>
<h2 style={{color: '#333'}}>Vendas sem conciliação</h2>
<table className='tableRef'>
    <tbody>
{checkSalesNotFoundInSaldo(salesData,financeData)?.map( item => {

    return <tr><td>{item?.sale_hash}</td> <td>{item?.payer_id_response?.name}</td><td>{item?.total}</td></tr>



})}
</tbody>
</table>

<h2 style={{color: '#333'}}>Vendas não pagas na conciliação</h2>
<table className='tableRef'>
    <tbody>
{checkSalesNotPaidInSaldo(salesData,financeData)?.map( item => {

    return <tr><td>{item?.hash}</td> <td>{item?.client}</td><td>{formatReal(item?.total)}</td></tr>



})}
</tbody>
</table>

<h2 style={{color: '#333'}}>Conciliação por categoria</h2>
 
<table className='tableRef'>
    <tbody>
        <tr><td>Categoria</td><td>Bruto</td><td>Dif. Antecipação</td><td>Taxa de Saque</td><td>Líquido</td><td>Saldo</td></tr>
{checkByOperation(  financeData)?.map( item => {

    return <tr><td>{item?.label}</td>  <td>{item?.total < 1 ? "(-)" : "(+)"}{formatReal(item?.total)}</td><td> { item?.antecipation_gap }</td><td> { item?.operation_fee }</td><td>{item?.net_total < 1 ? "(-)" : "(+)"}{formatReal(item?.net_total)}</td><td>{item?.saldo < 1 ? "(-)" : "(+)"}{formatReal(item?.saldo)}</td></tr>



})}
</tbody></table>

<h2 style={{color: '#333'}}>Linha a linha</h2>
<table className='tableRef'>
    <tbody>
{financeData?.map( item => {

    return <tr><td>{item?.hash}</td> <td>{item?.payer_id_response?.name}</td><td>{item?.total}</td></tr>



})}
</tbody>
</table>



</>



}

export default FinanceCheckComponent;